<!--
  密保设置
  lovi 2020-07-08
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        flag == 0
          ? $t('securitySet.securitySettings')
          : flag == 2
          ? $t('securitySet.securityVerification')
          : flag == 3
          ? $t('securitySet.newSecurityVerification')
          : $t('securitySet.securityQuestion')
      "
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span
        slot="right"
        v-if="flag == 1"
        class="text-blue"
        @click="changeQuestion"
      >
        {{ $t("securitySet.change") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <scroll>
        <div class="encrypted">
          <van-cell-group v-for="(item, index) in list" :key="index">
            <van-cell
              :title="
                language == 'en'
                  ? $t('securitySet.question') + (index + 1)
                  : $t('securitySet.question') +
                    (index == 0 ? '一' : index == 1 ? '二' : '三')
              "
              :value="item.question"
              :is-link="flag == 0 || flag == 3"
              @click="clickQuestion(item, index)"
            />
            <van-field
              v-model="item.answer"
              :label="$t('securitySet.answer')"
              :readonly="flag == 1"
              :placeholder="$t('securitySet.enterAnswer')"
            />
          </van-cell-group>
        </div>
        <div class="button-wrap" v-if="list.length && flag != 1">
          <van-button block type="primary" @click="submit">
            {{
              flag == 2 && payPsd == ""
                ? $t("common.verification")
                : $t("common.confirm")
            }}
          </van-button>
        </div>
      </scroll>
    </div>
    <!-- 选择问题 -->
    <van-popup v-model="questionFlag" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :title="$t('securitySet.selectQuestion')"
        :default-index="curIndex"
        :columns="question"
        @cancel="questionFlag = false"
        @confirm="confirm"
      />
    </van-popup>

    <transition name="slide">
      <pay-psd
        v-if="payPsdFlag"
        :payPsdFlag.sync="payPsdFlag"
        parentPage="verify"
        @getPayPsd="getPayPsd"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PayPsd from "@/views/common/payPsd";
export default {
  props: ["encryptedFlag", "username"],
  name: "encrypted",
  meta: {
    service: false // 客服
  },
  components: {
    PayPsd
  },
  data() {
    return {
      flag: 1, // 0设置问题 1密保问题 2旧密保验证 3新密保设置
      question: [],
      list: [],
      questionFlag: false,
      clickIndex: 0,
      curIndex: 0,
      payPsdFlag: false,
      payPsd: "",
      oldList: [],
      oldUsername: ""
    };
  },
  created() {
    if (this.encryptedFlag) {
      this.flag = 2;
      this.oldUsername = this.username;
      this.getUserSafeQuestionList();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo", "language"])
  },
  methods: {
    navBarBack() {
      // 返回
      if (this.encryptedFlag) {
        this.$emit("update:encryptedFlag", false);
      } else {
        this._back();
      }
    },
    changeQuestion() {
      // 更改问题
      let vm = this;
      vm.flag = 2;
      for (let i = 0; i < vm.list.length; i++) {
        vm.list[i].answer = "";
      }
    },
    getPayPsd(data) {
      // 获取支付密码
      console.log("getPayPsd", data);
      this.payPsd = data;
      if (this.flag == 0) {
        this.userSafeQuestion();
      }
      if (this.flag == 2) {
        this.UserSafeQuestionCheck();
      }
    },
    clickQuestion(data, index) {
      // 点击问题
      let vm = this;
      if (vm.flag == 0 || vm.flag == 3) {
        console.log("clickQuestion", data);
        vm.clickIndex = index;
        for (let i = 0; i < vm.question.length; i++) {
          if (data.id == vm.question[i].id) {
            vm.curIndex = i;
          }
        }
        vm.questionFlag = true;
        console.log("clickIndex", vm.clickIndex, "curIndex", vm.curIndex);
      }
    },
    confirm(picker) {
      // 选择问题
      let vm = this;
      vm.questionFlag = false;
      for (let i = 0; i < vm.list.length; i++) {
        if (picker.id == vm.list[i].id) {
          vm.$toast(vm.$t("securitySet.questionNotRepeated"));
          return;
        }
      }
      vm.list[vm.clickIndex] = picker;
      console.log("list", vm.list);
    },
    submit() {
      // 设置密保问题
      let vm = this;
      if (vm.flag == 0) {
        // 设置密保问题
        vm.userSafeQuestion();
      }
      if (vm.flag == 2 || vm.encryptedFlag) {
        // 验证问题
        vm.UserSafeQuestionCheck();
      }
      if (vm.flag == 3) {
        // 设置新密保问题
        vm.changeSafeQuestion();
      }
    },
    problemProcessing() {
      // 提交问题处理
      let vm = this;
      let list = [];
      for (let i = 0; i < vm.list.length; i++) {
        if (vm.list[i].answer == "") {
          vm.$toast(vm.$t("securitySet.enterAnswer"));
          return JSON.stringify(list);
        }
        let obj = {};
        obj.id = vm.list[i].id;
        obj.answer = vm.list[i].answer;
        list.push(obj);
      }
      return JSON.stringify(list);
    },
    changeSafeQuestion() {
      // 修改密保问题
      let vm = this;
      let params = {};
      params.pay_password = vm.payPsd;
      params.question = vm.oldList;
      params.new_question = vm.problemProcessing();
      vm.$post("/app/user/changeSafeQuestion", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("changeSafeQuestion", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.flag = 1;
          vm.payPsd = "";
          vm.getUserSafeQuestionList();
        }
      });
    },
    UserSafeQuestionCheck() {
      // 根据用户名校验密保问题
      let vm = this;
      let params = {};
      let question = vm.problemProcessing();
      if (JSON.parse(question).length < 3) {
        return false;
      }
      if (!vm.encryptedFlag && vm.payPsd == "") {
        // 验证支付密码
        vm.payPsdFlag = true;
        return;
      }
      params.username = vm.oldUsername;
      params.question = question;
      vm.$post("/app/user/UserSafeQuestionCheck", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("UserSafeQuestionCheck", res);
        if (res.code == 0) {
          if (vm.encryptedFlag) {
            vm.$emit("getEncrypted", params.question);
            vm.$emit("update:encryptedFlag", false);
            vm.$emit("update:setPsdFlag", true);
          } else {
            vm.flag = 3;
            vm.oldList = vm.problemProcessing();
            vm.getSafeQuestion();
          }
        } else {
          vm.payPsd = "";
          vm.$toast(res.msg);
        }
      });
    },
    userSafeQuestion() {
      // 设置密保问题
      let vm = this;
      let params = {};
      let question = vm.problemProcessing();
      if (JSON.parse(question).length < 3) {
        return false;
      }
      if (vm.payPsd == "") {
        // 验证支付密码
        vm.payPsdFlag = true;
        return;
      }
      params.question = question;
      params.pay_password = vm.payPsd;
      vm.$post("/app/user/userSafeQuestion", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("userSafeQuestion", res);
        vm.$toast(res.msg);
        vm.payPsd = "";
        if (res.code == 0) {
          vm.flag = 1;
          vm.$store.dispatch("GET_USER_INFO");
          vm.oldUsername = vm.userInfo.username;
          vm.getUserSafeQuestionList();
        }
      });
    },
    getUserSafeQuestionList() {
      // 获取问题详情
      let vm = this;
      let params = {};
      params.username = vm.oldUsername;
      vm.$post("/app/user/getUserSafeQuestionList", params, {
        loading: true
      }).then(res => {
        console.log("getUserSafeQuestionList", res);
        let arr = [];
        for (let i = 0; i < res.length; i++) {
          let obj = {};
          obj = res[i];
          obj.text = res[i].question;
          if (vm.encryptedFlag) {
            obj.answer = "";
          } else {
            obj.answer = "******";
          }
          arr.push(obj);
        }
        vm.list = arr;
        console.log("list", vm.list);
      });
    },
    getSafeQuestion() {
      // 获取问题列表
      let vm = this;
      vm.$post("/app/user/safeQuestion", {}, { loading: true }).then(res => {
        console.log("safeQuestion", res);
        let arr = [];
        for (let i = 0; i < res.length; i++) {
          let obj = {};
          obj = res[i];
          obj.text = res[i].question;
          obj.answer = "";
          arr.push(obj);
        }
        vm.question = arr;
        vm.list = vm.question.slice(0, 3);
        console.log("list", vm.list);
        console.log("question", vm.question);
      });
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.safe_question == 1) {
          // 已设置密保
          this.flag = 1;
          this.oldUsername = this.userInfo.username;
          this.getUserSafeQuestionList();
        }
        if (obj.safe_question == 0) {
          // 未设置密保
          this.getSafeQuestion();
          this.flag = 0;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.encrypted {
  padding-left: 16px;
  /deep/.van-cell-group {
    padding: 5px 0;
    border-bottom: 1.1px solid #e4e4e4;
    &::after {
      border: 0;
    }
    .van-cell {
      padding-left: 0;
      &.van-field {
        padding-top: 5px;
      }
      &::after {
        content: normal;
      }
      &:first-child {
        padding-bottom: 0;
        .van-cell__title,
        .van-cell__value {
          font-size: 14px;
          color: #2042ab;
          line-height: 1.2;
        }
      }
      // &:last-child {
      //   padding-top: 0;
      // }
      .van-cell__title {
        font-size: 14px;
        width: 70px;
        flex: initial;
      }
      .van-cell__value {
        text-align: left;
      }
    }
  }
}
</style>
